module.exports = __webpack_public_path__ + "static/media/infoWhite.05aeb498.png";